import environments from './XEnvironment.js';
import { XTemplateDOM } from './XDOM.js';
import { xArray, xObject, xReference, xString } from './XTypes.js';

import template from './XBlockStructure.html?raw';

import { XBlockEditorDecorator } from './XBlock.js';

export class XBlockStructure
{
    static get type () { return 'XBlockStructure'; }

    #dom;
    #parent;
    #section;
    #content;
    #page;
    #site;

    #blocks;

    constructor(dom, parent, section, content, page, site)
    {
        this.#dom     = dom;
        this.#parent  = parent;
        this.#section = section;
        this.#content = content;
        this.#page    = page;
        this.#site    = site;

        const domTypes = environments.active.domTypes;
        this.#blocks = this.#dom.blocks._setCreator(() => ({
                     XBlock: model => new domTypes.XBlock         (model, this, section, content, page, site),
            XBlockStructure: model => new domTypes.XBlockStructure(model, this, section, content, page, site),
        }));
    };

    calculateBlocksFlattened()
    {
        const blocks = [];
        for(const block of this.#blocks)
        {
            blocks.push(...block.calculateBlocksFlattened());
        }
        return blocks;
    }

    get blockDepth()
    {
        return this.#parent.blockDepth + 1;
    }

    get _dom    () { return this.#dom;     }
    get parent  () { return this.#parent;  }
    get section () { return this.#section; }
    get content () { return this.#content; }
    get page    () { return this.#page;    }
    get site    () { return this.#site;    }
    get blocks  () { return this.#blocks;  }
};

export class XBlockStructureReactive extends XBlockStructure
{
    static get specification () 
    {
        return xObject({
            $: XBlockStructure.type,
            type: xString('ul'),
            blocks: xArray(xReference('XBlock'))
        });
    }

    static #template;

    static initDOM(domEnvironment)
    {
        this.#template = new XTemplateDOM(template, XBlockStructureReactive.specification, domEnvironment);
    }

    #data;

    #blockEditor;

    constructor(data, parent, section, content, page, site)
    {
        super(XBlockStructureReactive.#template._createAccessibleDOM(data), parent, section, content, page, site);
        this.#data = data;

        this._dom._attachData(this.#data.type_, {
            _setValue: (value) => {
                this._dom._changeElementType(value._value);
            }
        });
        this._dom.blocks._addAttachment({
            _create: () => {
                this.section.updateBlocksFlattened();
            }
        }, false);

        this.#blockEditor = new XBlockEditorDecorator(this);
    };

    get data () { return this.#data; }
};
